// src/config/searchPages.js
export const SEARCH_PAGES = [
  { title: 'Home', path: '/' },
  { title: 'FAQ', path: '/faq' },
  { title: 'Track Order', path: '/TrackOrder' },
  { title: 'Appointment', path: '/appointment' },
  { title: 'Perfect Fit Guarantee', path: '/perfect-fit' },
  { title: 'Return Policy', path: '/return-policy' },
  { title: 'Return Instructions', path: '/return-instructions' },
  { title: 'Shipping & Delivery', path: '/shipping-delivery' },
  { title: 'Terms & Conditions', path: '/terms-and-conditions' },
  { title: 'Privacy Policy', path: '/privacy-policy' },
  { title: 'About Us', path: '/about' },
  { title: 'Help Center', path: '/help' },
  { title: 'Cart', path: '/cart' },
  { title: 'Wishlist', path: '/wishlist' },
  { title: 'Past Orders', path: '/past-orders' },
];
